import { PropsWithChildren } from 'react'
import styled from 'styled-components'
import {
  flex,
  flexbox,
  FlexboxProps,
  space,
  SpaceProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  typography,
  TypographyProps,
  border,
  BorderProps,
  color,
  ColorProps,
  PositionProps,
  position,
} from 'styled-system'

type Props = FlexboxProps &
  SpaceProps &
  GridProps &
  LayoutProps &
  TypographyProps &
  BorderProps &
  ColorProps &
  PositionProps

const Flex = styled('div')<PropsWithChildren<Props>>(
  {
    display: 'flex',
  },
  flex,
  flexbox,
  space,
  color,
  grid,
  layout,
  typography,
  border,
  color,
  position,
)

export default Flex
